// "panel" = filter icon in the header + panel under it, "card" = collapsible Advanced Filter card
export const PageHeaderFilterVariant = {
    PANEL: "panel",
    CARD: "card",
};
